"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { Check, Copy } from "lucide-react";
import stripAnsi from "strip-ansi";
import { Button } from "@repo/blacksmith-ui/button";
import { cn } from "@repo/blacksmith-ui/cn";
interface CopyButtonProps {
  /** The text to copy to the clipboard. ANSI codes are automatically stripped. */
  text: string;
  /** Tooltip / accessible title for the button. */
  title?: string;
  /** Extra classes merged onto the root button. */
  className?: string;
  /** When true, calls `e.stopPropagation()` on click (useful inside clickable containers). */
  stopPropagation?: boolean;
}
export function CopyButton(t0) {
  const $ = _c(12);
  const {
    text,
    title: t1,
    className,
    stopPropagation: t2
  } = t0;
  const title = t1 === undefined ? "Copy" : t1;
  const stopPropagation = t2 === undefined ? false : t2;
  const [copied, setCopied] = useState(false);
  let t3;
  if ($[0] !== stopPropagation || $[1] !== text) {
    t3 = e => {
      if (stopPropagation) {
        e.stopPropagation();
      }
      navigator.clipboard.writeText(stripAnsi(text)).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }).catch(_temp);
    };
    $[0] = stopPropagation;
    $[1] = text;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleCopy = t3;
  let t4;
  if ($[3] !== className) {
    t4 = cn("absolute top-2 right-2 p-2 rounded-md bg-neutral-800/80 hover:bg-neutral-700/80 text-white hover:text-white dark:text-white dark:hover:text-white opacity-0 group-hover:opacity-100 focus:opacity-100 transition-all duration-200", className);
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== copied) {
    t5 = copied ? <Check className="size-4 text-green-400" /> : <Copy className="size-4" />;
    $[5] = copied;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== handleCopy || $[8] !== t4 || $[9] !== t5 || $[10] !== title) {
    t6 = <Button variant="inline" onClick={handleCopy} className={t4} title={title}>{t5}</Button>;
    $[7] = handleCopy;
    $[8] = t4;
    $[9] = t5;
    $[10] = title;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function _temp() {}